import { PieChart, PieChartProps } from 'components/pie-chart';
import { copyFor } from 'config';
import { money } from 'utils/format';
import {
  PieWrapper,
  TextCallout,
  TextContent,
  TextHeader,
  TextTotal,
  pieColors,
} from '../pie-carousel.style';

type SolarFarmProductionProps = {
  options: PieChartProps['options'];
  savings: { percentage: number; total: number };
  solar: { percentage: number; total: number };
  utility: { percentage: number; total: number };
  utilityNames: string;
  total: number;
};

const getCopy = copyFor('billing.statement.pieCharts.solarFarmProduction');

export const SolarFarmProduction: React.FC<SolarFarmProductionProps> = ({
  options,
  savings,
  solar,
  utility,
  utilityNames,
  total,
}) => (
  <PieWrapper>
    <TextHeader>{getCopy('header')}</TextHeader>
    <PieChart
      data={{
        datasets: [
          {
            data: [savings.percentage, utility.percentage, solar.percentage],
            backgroundColor: [
              pieColors.savings,
              pieColors.gray,
              pieColors.solar,
            ],
            borderWidth: [0, 0, 0],
            offset: [60, 0, 0],
            rotation: 200,
          },
        ],
      }}
      height="200px"
      width="200px"
      options={options}
    />
    <TextTotal>{money(total)}</TextTotal>
    <TextCallout>{getCopy('callout', { utility: utilityNames })}</TextCallout>
    <TextContent>{getCopy('content', { utility: utilityNames })}</TextContent>
  </PieWrapper>
);
